import FaqPage from '@/components/feature/FaqPage';

export default function BpQ2Page() {
  return (
    <FaqPage
      category="Billing & Payments"
      categoryPath="/"
      icon="ri-bank-card-line"
      title="I don't recognize this charge — what should I do?"
      intro="Report and resolve charges you don't recognize on your account. Follow these steps to identify and dispute unfamiliar transactions."
      sections={[
        {
          heading: 'Step 1: Check your purchase history',
          content: [
            'Log in to your account and go to Account Settings > Billing History. Review your recent transactions to see if the charge matches any of your purchases or active subscriptions.',
            'Sometimes charges may appear under a different merchant name on your bank statement. Look for "London App Syndicate" or "LNDN" as the descriptor.',
          ],
        },
        {
          heading: 'Step 2: Check for shared account access',
          content: [
            'If you share your account with family members or colleagues, the charge may have been made by someone else with access to your account.',
            'Review your account\'s active sessions and recent activity in Account Settings > Security.',
          ],
        },
        {
          heading: 'Step 3: Contact our support team',
          content: [
            'If you still cannot identify the charge, please contact our support team immediately with the following information: the charge amount, the date it appeared, and the last 4 digits of the card charged.',
            'Our team will investigate and provide a full explanation within 24–48 hours.',
          ],
        },
        {
          heading: 'Step 4: Dispute the charge',
          content: [
            'If our investigation confirms the charge was made in error or without your authorization, we will issue a full refund promptly.',
            'You can also submit a formal dispute resolution request using our Dispute Resolution Form for a structured review process.',
          ],
        },
      ]}
    />
  );
}
